import React from "react";
import "./questionAndAnswer.scss";
import PropTypes from "prop-types";
import AttendeeChip from "../Attendees/AttendeeChip/AttendeeChip";
import {formatTimestamp} from "../helpers/utility";

export const TYPES = {
    QUESTION_ANSWER: 'QUESTION_ANSWER',
    OBJECTIONS: 'OBJECTIONS'
}
const UNHANDLED_QUESTION = "Unanswered Question";
const UNHANDLED_OBJECTION = "Unhandled Objection";

const QuestionAndAnswer = ({questionAndAnswers, type}) => {

    const speakerWithColors = questionAndAnswers.reduce( (acc, {questionBy, answerBy}) => {
        let speakerWithColors = acc;
        if(!acc[questionBy]) {speakerWithColors = [...acc, questionBy]}
        if(answerBy && !acc[answerBy]) {speakerWithColors = [...acc, answerBy]}
        return speakerWithColors;
    }, []);

    return <>
        {questionAndAnswers.map(({questionTime, question, answer, questionBy, answerBy}, index) => {
            return <div key={index}
                     className={"question-answer-container"}>
                    <p className={questionTime && "time-offset"}>{formatTimestamp(questionTime)}</p>
                    <div className={"question-answer"}>
                        <div className={"question-container"}>
                            <AttendeeChip name={questionBy} index={speakerWithColors.indexOf(questionBy)}/>
                            <p className={"question"}>{question}</p>
                        </div>
                        {
                            !!answer ? <div className={"answer-container"}>
                                    <AttendeeChip name={answerBy} index={speakerWithColors.indexOf(answerBy)}/>
                                    <p className={"answer"}>{answer}</p>
                                </div>
                                : <p className={"unhandled"}>{type === TYPES.QUESTION_ANSWER ? UNHANDLED_QUESTION : UNHANDLED_OBJECTION}</p>
                        }
                    </div>
                </div>
            }
        )}
    </>
};

QuestionAndAnswer.prototype = {
    questionAndAnswers: PropTypes.arrayOf(PropTypes.shape({
        timeOffset: PropTypes.string,
        question: PropTypes.shape({
            speaker: PropTypes.shape({
                email: PropTypes.string,
                id: PropTypes.string,
                name: PropTypes.string
            }),
            text: PropTypes.string
        }),
        answer: PropTypes.shape({
            speaker: PropTypes.shape({
                email: PropTypes.string,
                id: PropTypes.string,
                name: PropTypes.string
            }),
            text: PropTypes.string
        })
    })),
    type: PropTypes.string
}

export default QuestionAndAnswer;